import { render, staticRenderFns } from "./AddProductWhithVariants.vue?vue&type=template&id=668a1ce6&scoped=true"
import script from "./AddProductWhithVariants.vue?vue&type=script&lang=js"
export * from "./AddProductWhithVariants.vue?vue&type=script&lang=js"
import style0 from "./AddProductWhithVariants.vue?vue&type=style&index=0&id=668a1ce6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668a1ce6",
  null
  
)

export default component.exports